export default "__VITE_ASSET__d6c0a055__"